<template>
  <div class="">
    <a-upload accept=".png, .jpg, .jpeg" list-type="picture-card" v-model:file-list="fileList" :multiple="true"
      @preview="handlePreview" :before-upload="beforeUpload" :custom-request="customRequest"
      @change="handleUploadChange" :disabled="canuseUpload">
      <div v-if="(props.maxCount && fileList.length < props.maxCount) || !props.maxCount">
        <plus-outlined />
        <div class="ant-upload-text">上传图片</div>
      </div>
    </a-upload>
  </div>

  <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
    <img alt="example" style="width: 100%" :src="previewImage" />
  </a-modal>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import { message } from "ant-design-vue";
import { useStore } from "vuex";
import { uploadAttachment } from "@/request/view/repair";
import { Toast } from "@/utils";
import { useRoute } from "vue-router";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export default defineComponent({
  props: {
    attachment: String,
    disabled: Boolean,
    requestFn: Function,
    maxCount: Number,
    uploadFileName: String,
  },
  setup(props, context) {
    const store = useStore();
    const fileList = ref([]);
    const canuseUpload = ref(false);
    const setFileList = (list) => {
      const time = new Date();
      list.forEach((url) => {
        const name = url.slice(url.lastIndexOf("/") + 1, url.length);
        fileList.value.push({
          uid: time.getTime() + Math.random(5),
          status: "done",
          name,
          url,
        });
      });
    };

    const previewVisible = ref(false);
    const previewImage = ref("");
    const handlePreview = async (file) => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      previewImage.value = file.url || file.preview;
      previewVisible.value = true;
    };
    const handleCancel = () => {
      previewVisible.value = false;
    };
    // 上传之前的检验
    const beforeUpload = (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("请上传图片");
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        message.error("图片大小不能超过5M!");
      }
      return isJpgOrPng && isLt5M;
    };

    const uploadFile = (cb) => {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        let needUpload = false;
        fileList.value.forEach((file) => {
          if (file.url) {
            return;
          }
          needUpload = true;

          const fileName = props.uploadFileName ? props.uploadFileName : 'files';

          formData.append(fileName, file.originFileObj);
        });

        if (!needUpload) {
          let fileUrl = [];
          fileList.value.forEach((item) => {
            fileUrl.push(item.url);
          });
          resolve(fileUrl);
          return;
        }

        if (cb) cb();
        let reqFn =
          props.requestFn === undefined ? uploadAttachment : props.requestFn;
        reqFn(formData)
          .then((res) => {
            if (res.code === 200) {
              const cacheFile = [];
              fileList.value.forEach((item) => {
                if (item.url) {
                  cacheFile.push(item.url);
                }
              });
              if (Object.prototype.toString.call(res.data) === '[object Array]') {
                cacheFile.push(...res.data);
              }
              if (Object.prototype.toString.call(res.data) === '[object String]') {
                cacheFile.push(res.data);
              }
              resolve(cacheFile);
            } else {
              reject();
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    };

    const handleUploadChange = (file) => {
      console.log("文件上传", file);
      file.file.status = "done";
    };

    const customRequest = () => {
      console.log("upload");
    };

    const isImg = (str) => {
      return (
        str.indexOf("png") !== -1 ||
        str.indexOf("jpg") !== -1 ||
        str.indexOf("jpeg") !== -1
      );
    };

    const getFile = (str) => {
      str = String(str);
      if (str.indexOf('[') !== -1) {
        return JSON.parse(str);
      }
      return str.split(',')
    };

    watch(
      () => props.attachment,
      (val, oldval) => {
        fileList.value.length = 0;

        if (!val) return
        const imgList = getFile(val).filter((item) => isImg(item));

        setFileList(imgList);

      },
      {
        immediate: true,
        deep: true,
      }
    );

    watch(
      () => props.disabled,
      (val) => {
        canuseUpload.value = val;
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      handlePreview,
      fileList,
      previewVisible,
      handleCancel,
      previewImage,
      beforeUpload,
      uploadFile,
      customRequest,
      handleUploadChange,
      setFileList,
      canuseUpload,
    };
  },
});
</script>

<style lang="less" scoped></style>
